import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M21.4138 15.9158L9.31373 28.0159C8.89542 28.4342 8.89542 29.1125 9.31373 29.5309C9.73217 29.9492 10.4104 29.9492 10.8288 29.5309L23.6863 16.6733C24.1046 16.255 24.1046 15.5767 23.6863 15.1583L10.8288 2.30076C10.4031 1.88967 9.72482 1.90147 9.31373 2.32712C8.91275 2.74236 8.91275 3.40062 9.31373 3.81579L21.4138 15.9158Z' })
));